export const ProductListFilterSortPanelDesktopTexts = {
  termLabel: 'На срок',
  amountLabel: 'Мне нужно',
  amountError: 'от 3 000 до 100 000 ₽',
  termError: 'от 5 до 365 дней',
};
